import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { TbShirtFilled } from "react-icons/tb";

const mapOscuro = (v) => (Number(v) === 2 ? "Local" : "Visitante");

export default function ConfirmAssignModal({
    open,
    onClose,
    onConfirm,
    isAssigning = false,
    count = 0,
    localParam = 2,
    faseLabel = "",
}) {
    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-[70]" onClose={onClose}>
                {/* Overlay */}
                <Transition.Child
                    as={Fragment}
                    enter="transition-opacity ease-out duration-150"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transition-opacity ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/40" />
                </Transition.Child>

                {/* Panel */}
                <div className="fixed inset-0 z-[71] overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="transition ease-out duration-150 transform"
                            enterFrom="opacity-0 scale-95 translate-y-1"
                            enterTo="opacity-100 scale-100 translate-y-0"
                            leave="transition ease-in duration-100 transform"
                            leaveFrom="opacity-100 scale-100 translate-y-0"
                            leaveTo="opacity-0 scale-95 translate-y-1"
                        >
                            <Dialog.Panel className="w-full max-w-md rounded-2xl bg-white p-5 text-left shadow-xl ring-1 ring-black/5">
                                <div className="flex items-start gap-3">
                                    <div className="mt-1 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-indigo-50 ring-1 ring-inset ring-indigo-200">
                                        <TbShirtFilled className="h-5 w-5 text-indigo-700" />
                                    </div>
                                    <div className="min-w-0">
                                        <Dialog.Title className="text-base font-semibold text-gray-900">
                                            ¿Asignar camisetas ahora?
                                        </Dialog.Title>
                                        <div className="mt-1 text-sm text-gray-600">
                                            <p>
                                                Se aplicará la asignación de camisetas a{" "}
                                                <strong>{count}</strong> partido(s) visible(s) en{" "}
                                                <strong>{faseLabel || "la vista actual"}</strong>.
                                            </p>
                                            <ul className="mt-2 space-y-1 text-[13px]">
                                                <li>• Oscuro para: <strong>{mapOscuro(localParam)}</strong></li>
                                                <li>• Esta acción puede sobrescribir uniformes ya guardados.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* Acciones */}
                                <div className="mt-5 flex justify-end gap-2">
                                    <button
                                        type="button"
                                        onClick={onClose}
                                        className="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
                                        disabled={isAssigning}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="button"
                                        onClick={onConfirm}
                                        disabled={isAssigning}
                                        className={`inline-flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-semibold text-white
                      ${isAssigning ? "bg-indigo-400" : "bg-indigo-600 hover:bg-indigo-700"}`}
                                    >
                                        {isAssigning ? "Asignando…" : "Sí, asignar"}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
